import React, { useState, useEffect } from "react";
import {
  Popconfirm,
  Modal,
  Button,
  Table,
  Form,
  Input,
  Select,
  message,
  Switch,
  Checkbox
} from "antd";

import axios from "axios";
import DefaultLayout from "../components/DefaultLayout";
import CloseButton from "../components/CloseButton";
import Swal from "sweetalert2";
import config from "../config";

import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

const TaxesSetting = () => {
  const apiBaseUrl = config.REACT_APP_API_BASE_URL;

  const [taxesData, setTaxesData] = useState([]);
  const [popupModal, setPopupModal] = useState(false);
  const [editTaxes, setEditTaxes] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });
  const getAllTaxes = async () => {
    try {
      const { data } = await axios.get(`${apiBaseUrl}/api/taxes/get-taxes`);

      setTaxesData(data);

      console.log(data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getAllTaxes();
  }, []);

  //handle delete
  const handleDelete = async (record) => {
    try {
      await axios.post(`${apiBaseUrl}/api/taxes/delete-taxes`, {
        taxesId: record._id,
      });
      // message.success('Taxes Deleted Successfully')
      Swal.fire({
        title: "Success",
        text: "Tax Deleted Successfully",
        toast: true,
        icon: "success",
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
      getAllTaxes();
      setPopupModal(false);
    } catch (error) {
      // message.success('Something Went Wrong')
      // console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };

  //able data
  const columns = [
    {
      title: "No",
      key: "index",
      render: (text, record, recordIndex) => (
        <span>{(pagination.current - 1) * pagination.pageSize + recordIndex + 1}</span>
      ),
    },
    { title: "Tax Name", dataIndex: "name", sorter: (a, b) => a.name.localeCompare(b.name), showSorterTooltip: false },
    { title: "Tax Rate(%)", dataIndex: "rate", sorter: (a, b) => parseFloat(a.rate) - parseFloat(b.rate), showSorterTooltip: false },
    {
      title: "Valid for Take Away",
      dataIndex: "for_take_away",
      render: (text) => (text ? "Yes" : "No"),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Checkbox.Group
            style={{ display: 'flex', flexDirection: 'column' }}
            options={[
              { label: 'Yes', value: true },
              { label: 'No', value: false },
            ]}
            value={selectedKeys}
            onChange={(keys) => {
              setSelectedKeys(keys);
              confirm({ closeDropdown: false });
            }}
          />
          <Button
            onClick={() => {
              clearFilters();
              confirm();
            }}
            size="small"
            style={{ width: '100%', marginTop: 8 }}
          >
            Reset
          </Button>
        </div>
      ),
      onFilter: (value, record) => record.for_take_away === value,
      showSorterTooltip: false
    },
    { title: "Description", dataIndex: "description", sorter: (a, b) => (a.description || '').localeCompare(b.description || ''), showSorterTooltip: false },

    {
      title: "Actions",
      dataIndex: "_id",
      render: (id, record) => (
        <div className="action-icons">
          <EditOutlined
            style={{
              cursor: "pointer",fontSize: 22
            }}
            onClick={() => {
              setEditTaxes(record);
              setPopupModal(true);
            }}
          />
          <Popconfirm
            title="Are you sure you want to delete this record?"
            onConfirm={() => handleDelete(record)}
            okText="Yes"
            cancelText="No"
          >
            <DeleteOutlined style={{ cursor: "pointer", marginLeft: 8, fontSize: 22 }} />
          </Popconfirm>
        </div>
      ),
    },
  ];

  const handleCancel = () => {
    if (loading) {
      // message.warning("Proceed submitting...");
      return;
    }

    setPopupModal(false);
    setEditTaxes(null);
  };

  //handle submit
  const handleSubmit = async (value) => {
    setLoading(true);
    if (editTaxes === null) {
      try {
        const newValues = { ...value };
        const res = await axios.post(
          `${apiBaseUrl}/api/taxes/add-taxes`,
          newValues
        );
        // message.success('Taxes Added Successfully')
        Swal.fire({
          title: "Success",
          text: "Tax Added Successfully",
          toast: true,
          icon: "success",
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        getAllTaxes();
        setPopupModal(false);
      } catch (error) {
        // message.error('Something Went Wrong')
        Swal.fire({
          icon: "error",
          title: "Something Went Wrong",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
      } finally {
        setLoading(false);
      }
    } else {
      try {
        await axios.put(`${apiBaseUrl}/api/taxes/edit-taxes`, {
          ...value,
          taxesId: editTaxes._id,
        });
        // message.success('Category Updated Successfully')
        Swal.fire({
          title: "Success",
          text: "Tax Updated Successfully",
          toast: true,
          icon: "success",
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        getAllTaxes();
        setPopupModal(false);
      } catch (error) {
        message.error("Something Went Wrong");
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <DefaultLayout showSearch={false}>
      <div className="page-header">
        <h1 className="page-title">Tax</h1>
        <Button type="primary" onClick={() => setPopupModal(true)}>
          Add Tax
        </Button>
      </div>

      {/* <div className="d-flex justify-content-between">
        <h1>Tax</h1>
        <Button type="primary" onClick={() => setPopupModal(true)}>
          Add Tax
        </Button>
      </div> */}

      <Table columns={columns} dataSource={taxesData} bordered 
        //add pagination
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          pageSizeOptions: ['10', '20', '50', '100'],
          showSizeChanger: taxesData.length > 10,
          showTotal: (total, range) => `Showing ${range[0]}–${range[1]} of ${total} items`,
          onChange: (page, pageSize) => setPagination({ current: page, pageSize }),
        }} 
      />

      {popupModal && (
        <Modal
          // title={`${editTaxes !== null ? 'Edit Tax' : 'Add New Tax'}`}
          title={
            <div>
              {editTaxes !== null ? "Edit Tax" : "Add New Tax"}
              <CloseButton onClick={handleCancel} />
            </div>
          }
          open={popupModal}
          onCancel={handleCancel}
          footer={false}
        >
          <Form
            layout="vertical"
            initialValues={editTaxes}
            onFinish={handleSubmit}
          >
            <Form.Item
              name="name"
              label="Tax Name"
              rules={[
                { required: true, message: "Please input the tax name!" },
                {
                  min: 3,
                  message: "Tax name must be at least 3 characters long!",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="rate"
              label="Tax Rate(%)"
              rules={[
                { required: true, message: "Please input the tax rate!" },
                // {
                //   min: 0,
                //   max: 100,
                //   message: "Tax rate must be between 0 and 100!",
                // },
                {
                  validator: (_, value) => {
                    const num = parseFloat(value);
                    if (!num || num === undefined || num === null || num === "") {
                      return Promise.resolve(); // Let the 'required' rule handle empty values
                    }
                    if (num > 100) {
                      return Promise.reject("Tax rate must not exceed 100!");
                    }
                    return Promise.resolve();
                    
                  },
                }
              ]}
            >
              <Input type="number" />
            </Form.Item>

            <Form.Item
              name="for_take_away"
              label="Valid for Take Away"
              valuePropName="checked"
              initialValue={false}
            >
              <Switch />
            </Form.Item>

            <Form.Item
              name="description"
              label="Description"
              // Optional description, so no required rule
            >
              <Input />
            </Form.Item>

            <div className="d-flex justify-content-end ant-modal-footer">
              {/* <Button type="primary" htmlType="submit">
                  Save
                </Button> */}
              <Button
                type="primary"
                htmlType="submit"
                loading={loading} // Show loading spinner
                iconPosition="start" // Ensure the icon is positioned at the start
                disabled={loading} // Disable the button while loading
              >
                Save
              </Button>
            </div>
          </Form>
        </Modal>
      )}
    </DefaultLayout>
  );
};

export default TaxesSetting;
